/**
 * Handles scrolling effect
 * @module fixedScroll
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'fixedScroll';
export const SCROLL_EVENT = 'scroll';
export const FS_CLASS = '.js-fixed-scroll';
export const FS_FIXED_CLASS = 'fixed-scroll';
export const FS_ABSOLUTE_CLASS = 'absolute-scroll';
export const FS_HEADER_CLASS = '.js-site-header__wrapper';

export const DEFAULTS = {

};
/**
 * Handle Scroll Event
 * @param  {jQuery} $el - scroll Element
 */
const scrollEventHandler = ($el) => {
  let position = 0;
  let lastScrollTop = 0;
  let headerPosition = 0;
  let elementPosition = 0;
  $(window).on(SCROLL_EVENT, () => {
    const scroll = $(window).scrollTop();
    const top = scroll * -1;
    const scrollDiff = 400;
    const diffPosition = top - lastScrollTop;
    headerPosition += diffPosition;
    elementPosition += diffPosition;
    const elOrgY = $el.offset().top - 16;
    const elHeight = $el.outerHeight(true);
    const elParentHeight = $el.parent().outerHeight(true);
    const headerHeight = $(FS_HEADER_CLASS).outerHeight();
    const parentDiff = elParentHeight - elHeight;
    const distance = parentDiff + (headerHeight - 16);
    if (scroll > position) {
      if (scroll > elOrgY && scroll < distance) {
        $(FS_CLASS).addClass(FS_FIXED_CLASS);
      } else if (scroll > distance) {
        $(FS_CLASS).removeClass(FS_FIXED_CLASS).addClass(FS_ABSOLUTE_CLASS);
      }
    } else if (scroll < distance) {
      if (scroll <= 0) {
        $(FS_CLASS).removeClass(FS_FIXED_CLASS);
      } else {
        $(FS_CLASS).removeClass(FS_ABSOLUTE_CLASS).addClass(FS_FIXED_CLASS);
      }
    }

    if (headerPosition < -scrollDiff && diffPosition < 0) {
      headerPosition = -scrollDiff;
    } else if (headerPosition > 0) {
      headerPosition = 0;
    }

    if (headerPosition < -headerHeight || scroll > parentDiff) {
      elementPosition = 0;
    } else if (headerPosition === 0 && scroll === 0) {
      elementPosition = 0;
    } else if (headerPosition === 0 && scroll > 0) {
      elementPosition = headerHeight;
    } else if (headerPosition > -headerHeight && headerPosition < 0 && top < lastScrollTop) {
      elementPosition = 0;
    } else if (headerPosition > -headerHeight && headerPosition < 0 && top > lastScrollTop) {
      // elementPosition = 0;
    }

    $el.css({ transform: `translate3d(0px, ${elementPosition}px, 0px)` });
    lastScrollTop = top;
    position = scroll;
  });
};
/**
 * Set Event setEventListeners
 * @param  {jQuery} $el - dropdown wrap
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const applyEventHandlers = ($el, opts = {}) => {
  scrollEventHandler($el, opts);
};
/**
 * Initializes Fixed Scroll.
 * @param {HTMLElement} el - scroll Element
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function fixedScroll(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  applyEventHandlers($el, opts);
}
// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, fixedScroll);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/fixed-scroll.js